import React from 'react';
import { Helmet } from 'react-helmet'; 
import './Portfolio.scss';

// -------------------------------------------------------------------------------------------

const Portfolio = () => {
    return (
        <>
            <Helmet><title>Sergio Nava | Portfolio</title></Helmet>
            <div className="intro">
                <div>
                    <h2 className="f3 pb1">
                        Working on this page...
                    </h2>
                </div>
            </div>
        </>
    )
}

export default Portfolio;